import { SVGProps } from 'react';
import { colors } from '@/utils/styles';

export default function NextIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        opacity="0.5"
        d="M16.5568 32.3997C25.3033 32.3997 32.565 25.1508 32.565 16.3998C32.565 7.6488 25.2867 0.399902 16.5402 0.399902C7.80695 0.399902 0.565186 7.6488 0.565186 16.3998C0.565186 25.1508 7.82356 32.3997 16.5568 32.3997ZM13.5772 22.7182C12.8274 23.185 11.9642 22.8082 11.9642 22.0379V10.7851C11.9642 10.0149 12.8939 9.68794 13.5772 10.1048L22.7848 15.5494C23.4515 15.9531 23.4681 16.8968 22.7848 17.2838L13.5772 22.7182Z"
        fill={colors.neutral[0]}
      />
    </svg>
  );
}
